/* The Grief Gal | menu, testimonial carousel, and full-story pop-up */
(function () {
  function initMenu(root) {
    var btn = root.querySelector('[data-gg-menu-toggle]');
    var nav = root.querySelector('[data-gg-nav]');
    if (!btn || !nav || btn.dataset.ggReady) return;
    btn.dataset.ggReady = '1';
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
      btn.textContent = open ? btn.dataset.closeLabel : btn.dataset.openLabel;
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = btn.dataset.openLabel;
      });
    });
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-gg-track]');
    if (!track || track.dataset.ggReady) return;
    track.dataset.ggReady = '1';
    var prev = root.querySelector('[data-gg-prev]');
    var next = root.querySelector('[data-gg-next]');
    var dots = root.querySelector('[data-gg-dots]');
    var controls = root.querySelector('[data-gg-controls]');

    function metrics() {
      var cards = track.querySelectorAll('.gg-t-card');
      if (!cards.length) return null;
      var cw = cards[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 24;
      var per = Math.max(1, Math.round((track.clientWidth + gap) / (cw + gap)));
      return { cw: cw, gap: gap, per: per, pages: Math.ceil(cards.length / per) };
    }
    function update() {
      var m = metrics(); if (!m) return;
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 8;
      next.disabled = track.scrollLeft >= max - 8;
      if (dots.children.length !== m.pages) {
        dots.innerHTML = '';
        for (var i = 0; i < m.pages; i++) dots.appendChild(document.createElement('span'));
      }
      var idx = Math.min(m.pages - 1, Math.round(track.scrollLeft / ((m.cw + m.gap) * m.per)));
      if (track.scrollLeft >= max - 8) idx = m.pages - 1;
      Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-on', i === idx); });
      controls.hidden = m.pages <= 1;
    }
    function go(dir) { var m = metrics(); if (m) track.scrollBy({ left: dir * (m.cw + m.gap) * m.per }); }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();

    var dialog = root.querySelector('[data-gg-dialog]');
    if (!dialog) return;
    root.querySelectorAll('[data-gg-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.gg-t-card');
        dialog.querySelector('[data-gg-d-head]').innerHTML = card.querySelector('.gg-t-head').innerHTML;
        dialog.querySelector('[data-gg-d-title]').textContent = card.querySelector('h3').textContent;
        dialog.querySelector('[data-gg-d-body]').innerHTML = card.querySelector('.gg-t-full').innerHTML;
        if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
      });
    });
    dialog.querySelector('[data-gg-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-gg-header]').forEach(initMenu);
    (scope || document).querySelectorAll('[data-gg-carousel]').forEach(initCarousel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  /* Re-run when a section is edited in the Shopify theme editor */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
